import CustomButton from 'components/Button/CustomButton';
import EditIcon from 'components/Icons/editIcon';
import { cloneDeep } from 'lodash';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialog } from 'store/actions/dialogActions';
import selectors from 'store/selectors';
import { useAssigneesUtils } from 'utils/CustomHooks/useAssigneesUtil';
import DIALOGS from 'utils/dialogIds';

export const ActionsRender = (props) => {
  const { addNewAssignees } = useAssigneesUtils();
  const categoryList = useSelector(selectors.getServiceAdmin);
  const dispatch = useDispatch();

  const {
    template,
    actions,
    isWorkflows,
    showOverdueAndMissed,
    hideElements,
    noDefaultWatchersAndNotifiers,
  } = props;
  const { editSuccessHandler } = actions;

  const formattedTemplate = useMemo(() => {
    const copiedTemplate = cloneDeep(template);
    if (copiedTemplate) {
      delete copiedTemplate?.templateTitle;
      delete copiedTemplate?.templateDescription;
      delete copiedTemplate?.dueAfterCreationTime;

      const assignees = copiedTemplate?.Assignees?.map(
        (item) => item?.AssigneeId,
      );

      const ServiceType = categoryList?.find(
        (c) => c.id == copiedTemplate?.ServiceTypeId,
      );

      return {
        ...copiedTemplate,
        TaskAssignees: addNewAssignees(assignees),
        attachment: template?.attachment,
        ServiceType,
      };
    }
  }, [template]);

  const nextHandler = (
    data,
    templateInfo,
    isEdit,
    isWorkflows,
    hideElements,
    showOverdueAndMissed,
    noDefaultWatchersAndNotifiers,
  ) => {
    dispatch(
      setDialog({
        open: false,
        dialogId: 'editTask',
      }),
    );

    dispatch(
      setDialog({
        open: true,
        dialogId: DIALOGS.CREATE_EDIT_TASKS_TEMPLATE_DIALOG,
        data: {
          hideElements,
          isWorkflows,
          noDefaultWatchersAndNotifiers,
          showOverdueAndMissed,
          taskTemplate: {
            metaData: data,
            templateInfo: templateInfo,
          },
          isEdit: true,
          onSuccessCallBack: editSuccessHandler,
        },
      }),
    );
  };

  const handleEdit = () => {
    dispatch(
      setDialog({
        open: true,
        dialogId: 'editTask',
        data: {
          showOverdueAndMissed,
          isWorkflows,
          noDefaultWatchersAndNotifiers,
          dialogState: {
            taskTemplate: {
              isEdit: true,
            },
            viewLess: false,
            hideElements: hideElements || {
              dueDate: true,
              schedule: true,
              isRequiredChecklistCheckbox: true,
            },
            removeSubmitValidation: true,
          },
          actionBtn: {
            text: 'Next',
            clickHandler: nextHandler,
          },
          taskData: formattedTemplate,
          taskTemplateInfo: {
            ...(template?.dueAfterCreationTime && {
              dueAfterCreationTime: template?.dueAfterCreationTime,
            }),
            ...(template?.templateTitle && {
              templateTitle: template?.templateTitle,
            }),
            ...(template?.templateDescription && {
              templateDescription: template?.templateDescription,
            }),
            ...(template?.templateType && {
              templateType: template?.templateType,
            }),
            ...(template?.config && {
              config: template?.config,
            }),
          },
        },
      }),
    );
  };

  return (
    <CustomButton
      onClick={handleEdit}
      variant="outlined"
      startIcon={<EditIcon />}
      sx={{
        borderRadius: '8px',
        marginRight: '10px',
      }}
    >
      Edit
    </CustomButton>
  );
};
